// extracted by mini-css-extract-plugin
export var boxItems = "_8z-1";
export var boxItemsLg = "_8z-2";
export var button = "_8z-7";
export var buttonHoverless = "_8z-9";
export var buttonLg = "_8z-8";
export var filterGroupBox = "_8z-0";
export var icon = "_8z-3";
export var iconSecondary = "_8z-6";
export var iconWrapper = "_8z-4";
export var iconWrapperLg = "_8z-5";
export var truncatedLabel = "_8z-a";